export const attorneyFeeOptions: number[] = [
    25, 26, 27, 28, 29, 30, 31, 32, 33, 33.3, 34, 35, 36, 37, 38, 39, 40,
];

export const attorneyFeeOptionsWithNone = ["", ...attorneyFeeOptions];
